import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreditPageComponent } from './credit-page/credit-page.component';
import { CreditWrapperRoutingModule } from './credit-wrapper-routing.module';

@NgModule({
  imports: [CommonModule, CreditWrapperRoutingModule, CreditPageComponent],
})
export class CreditWrapperModule {
}
